const supportHours = {
  chat: { start: { hour: 8, minute: 0 }, end: { hour: 19, minute: 0 } },
  sms: { start: { hour: 8, minute: 0 }, end: { hour: 19, minute: 0 } },
  phone: { start: { hour: 7, minute: 0 }, end: { hour: 21, minute: 0 } }
};

const initialState = {
  faqs: [],
  videos: [],
  contentServiceRequestId: '',
  isSupportMenuOpen: false,
  isMobileSupportMenuOpen: false,
  isSupportContentLoading: false,
  supportHours,
  focusedVideoId: null,
  supportDropdown: {
    waitTimes: {
      entities: {
        chat: {},
        phone: {},
        sms: {}
      },
      isLoading: false,
      error: null
    }
  }
};

export default initialState;
